import {Inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {first, take} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class AgentsProfileHiperioService {

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public get(agencyUnitsId: string): Observable<any> {
    return this.httpClient.get(`/rest/crm/hiperio/agency-units/${agencyUnitsId}`)
      .pipe(first());
  }

  public activationStatusHiperioOfwcaUpdate(ofwcaId: string, status: string): Observable<any> {
    return this.httpClient.post(`/rest/crm/hiperio/agency-units/${ofwcaId}/activation`, {
      activationStatus : status
    }).pipe(first());
  }

  public getHiperioRegistrationConfig(id: string): Observable<any> {
    return this.httpClient.get(`/rest/crm/hiperio/registration-config/${id}`)
      .pipe(first());
  }
  public sendUpdateRegistration(param: {registration: any }, id: string): Observable<any> {
    return this.httpClient.put(`/rest/crm/hiperio/registration-config/${id}`, param);
  }
  public sendConcludeRegistration(param: {registration: any , hiperioConfig: any  }, ofwcaId: string): Observable<any> {
    return this.httpClient.put(`/rest/crm/hiperio/conclusion-change-registration/${ofwcaId}`, param);
  }

  public sendUpdateParameter(param: any): Observable<any> {
    return this.httpClient.put(`/rest/crm/hiperio/parameter-config`, param);
  }

  public getParameter(agencyUnitsId: string, productId: string | null = null ): Observable<any> {
    return this.httpClient.get(`/rest/crm/hiperio/parameter-config/${agencyUnitsId}/${productId}`)
      .pipe(first());
  }

  public getCredentials(agencyUnitsId: string, productId: string | null = null): Observable<any> {
    return this.httpClient.get(`/rest/crm/hiperio/credentials/${agencyUnitsId}/${productId}`)
      .pipe(first());
  }

  public sendTestAccessForm(ofwcaId: string): Observable<any> {
    return this.httpClient.post(`/rest/crm/hiperio/test-access-form`,
      {
        ofwca: ofwcaId,
      })
      .pipe(take(1));
  }


}
